// Per-device appearance: dark (default), light, or follow the system.
import { ref } from 'vue'

export type ThemeChoice = 'dark' | 'light' | 'system'

const KEY = 'hearth:theme'
const media = (): MediaQueryList | null => globalThis.matchMedia?.('(prefers-color-scheme: light)') ?? null

export function storedTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY)
    if (v === 'dark' || v === 'light' || v === 'system') return v
  } catch {
    // storage unavailable
  }
  return 'dark'
}

export function resolveTheme(choice: ThemeChoice, prefersLight = media()?.matches ?? false): 'dark' | 'light' {
  return choice === 'system' ? (prefersLight ? 'light' : 'dark') : choice
}

/** The theme on screen now (palette colours are drawn adjusted to it). */
export const activeTheme = ref<'dark' | 'light'>('dark')

function apply(choice: ThemeChoice): void {
  const t = resolveTheme(choice)
  activeTheme.value = t
  document.documentElement.dataset.theme = t
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', t === 'light' ? '#ffffff' : '#000000')
  // The Android app draws the strips behind the status and navigation bars (MainActivity).
  ;(globalThis as { hrthBars?: { setLight(light: boolean): void } }).hrthBars?.setLight(t === 'light')
}

export function setTheme(choice: ThemeChoice): void {
  try {
    localStorage.setItem(KEY, choice)
  } catch {
    // storage unavailable: still applies for this session
  }
  apply(choice)
}

/** Applies the stored theme and follows system changes when set to "system". */
export function initTheme(): void {
  apply(storedTheme())
  media()?.addEventListener?.('change', () => {
    if (storedTheme() === 'system') apply('system')
  })
}
